import { HttpEventType } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { RequestState } from "@app-common/http/RequestState";
import { ToasterService, ToasterType } from "@app-service/toaster.service";
import { UserService } from "@app-service/user.service";
import { UnreportedReceiptService } from "@app/expense-management/services";

@Component({
    selector: "app-whatsapp-expense-receipt-upload",
    templateUrl: "./whatsapp-expense-receipt-upload.component.html",
    styleUrls: ["./whatsapp-expense-receipt-upload.component.scss"],
    standalone: false
})
export class WhatsappExpenseReceiptUploadComponent implements OnInit {
  modalTitle = "Upload Receipt";
  receiptId: string = null;
  isfileUploadState: boolean = true;
  isDataLoading = false;
  allowedFileTypes: string[] = [
    "application/pdf",
    "image/png",
    "image/jpeg",
    "image/jpg",
  ];
  fileuploadState: RequestState;
  fileList = [];

  constructor(
    private toastService: ToasterService,
    private route: ActivatedRoute,
    private unreportedReceiptService: UnreportedReceiptService,
    private userService: UserService
  ) {
    this.userService.showHaderImage(true);
    this.userService.showHaderSetting(false);
    this.userService.hideSideNav(true);

    this.route.params.subscribe((params) => {
      if (params && params?.uuid && typeof params["uuid"] === "string") {
        this.receiptId = params["uuid"];
      }
    });
  }

  checkFileFormatForUpload(fileList) {
    for (const file of fileList) {
      if (!this.allowedFileTypes.includes(file.type)) {
        this.toastService.showToaster(
          `Only '.pdf, .jpeg/.jpg or .png' files can be uploaded.`,
          ToasterType.WARNING
        );
        return false;
      }

      if (file.size > 5000000) {
        this.toastService.showToaster(
          "File cannot be greater than 5MB in size.",
          ToasterType.WARNING
        );
        return false;
      }
    }
    return true;
  }

  onFileDropped(e) {
    this.fileList = Array.from(e);
    if (!this.checkFileFormatForUpload(this.fileList)) {
      this.fileList = [];
    }
  }

  uploadFile(event) {
    const em = event.target as HTMLInputElement;
    if (em.files && em.files.length) {
      this.fileList = Array.from(em.files);
      if (!this.checkFileFormatForUpload(this.fileList)) {
        this.fileList = [];
      }
    }
  }

  attachFile() {
    this.fileuploadState.pending();
    if (this.receiptId) {
      this.unreportedReceiptService
        .whatsappReceiptUploadExpense(this.fileList[0], this.receiptId)
        .subscribe(
          (event) => {
            if (event.type === HttpEventType.UploadProgress) {
            } else if (event.type === HttpEventType.Response) {
              this.fileuploadState.completed();
              this.isfileUploadState = false;
            }
          },
          (error) => {
            this.fileuploadState.rejected();
            const errorJson = error["error"];
            if (errorJson) {
              const errorMsg = errorJson["error"]
                ? errorJson["error"]
                : errorJson["response_message"]
                ? errorJson["response_message"]
                : errorJson["message"]
                ? errorJson["message"]
                : "Internal Error";
              this.toastService.showToaster(errorMsg, ToasterType.ERROR);
            } else {
              this.toastService.showToaster(
                "Internal Error",
                ToasterType.ERROR
              );
            }
            this.isfileUploadState = true;
          }
        );
    }
  }

  ngOnInit(): void {
    this.fileuploadState = RequestState.init();
  }

  ngOnDestroy(): void {
    this.fileList = [];
  }
}
